import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_ADMIN_FULFILLMENT_TESTING_CENTER = `${URL_PARTNER_SCOPED}/fulfillment-testing-center`
const URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDERS = `${URL_ADMIN_FULFILLMENT_TESTING_CENTER}/orders`
const URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDER_SIMULATOR = `${URL_ADMIN_FULFILLMENT_TESTING_CENTER}/warehouse/:warehouse_id/orders/:orderId/order-simulator`
// @hygen:inject admin-urls

const ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER = `${URL_RETAILER_SCOPED}/fulfillment-testing-center`
const ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDERS = `${ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER}/orders`
const ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDER_SIMULATOR = `${ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER}/orders/:orderId/order-simulator`

export type DashRouteSet =
  | DashRouteType<'app-dev-portal-fulfillment-testing-center'>
  | DashRouteType<'ftc-orders'>
  | DashRouteType<'ftc-order-simulator'>
  | DashRouteType<'enhanced-app-dev-portal-fulfillment-testing-center'>
  | DashRouteType<'enhanced-ftc-orders'>
  | DashRouteType<'enhanced-ftc-order-simulator'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-dev-portal-fulfillment-testing-center': URL_ADMIN_FULFILLMENT_TESTING_CENTER,
  'ftc-orders': URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDERS,
  'ftc-order-simulator': URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDER_SIMULATOR,
  'enhanced-app-dev-portal-fulfillment-testing-center':
    ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER,
  'enhanced-ftc-orders': ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDERS,
  'enhanced-ftc-order-simulator': ENHANCED_URL_ADMIN_FULFILLMENT_TESTING_CENTER_ORDER_SIMULATOR,
  // @hygen:inject route-pair
}

export enum routeConfig {
  orders = 'ftc-orders',
  orderSimulator = 'ftc-order-simulator',
  enhancedOrders = 'enhanced-ftc-orders',
  enhancedOrderSimulator = 'enhanced-ftc-order-simulator',
}

export type RouteSetIdentifier = DashRouteSet['identifier']
export type DomainRouteName = keyof typeof routes
